export default "__VITE_ASSET__CJUVXwYL__"